// extracted by mini-css-extract-plugin
module.exports = {"OffersItems":"Offers_OffersItems__3yFYe","Offers":"Offers_Offers__nnm8S","SpinnerWrapper":"Offers_SpinnerWrapper__3cruZ"};